module.exports = __webpack_public_path__ + "oops.mp3";